/*
 *
 * UserPreferences constants
 *
 */
export const REDUCER_KEY = 'UserPreferences';
export const UPDATE_TEAM_FILTER = 'app/UserPreferences/UPDATE_TEAM_FILTER';
export const RESET_TEAM_FILTER = 'app/UserPreferences/RESET_TEAM_FILTER';
